module.exports = __webpack_public_path__ + "static/media/banner.f401ef0e.png";